function validate_password(password) {
	var regexExp = new RegExp(
		'^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*[*.!@$%^&]).{8,}$'
	);
	return regexExp.test(password);
}

export default validate_password;
